<div class="grid-wrapper w-100 h-100 slim-scroll thin">
    <ng-container *ngIf="config">
        <ng-container *ngIf="!config?.hideHeaderPanel">
            <div class="cs-list-header">
                <div class="title-wrapper">
                    <h4 class="header-title" translate>{{ config.headerPanelConfig?.title }}</h4>
                    <div *ngIf="config.headerPanelConfig?.helpText" class="help-text" translate>{{ config.headerPanelConfig?.helpText }}</div>
                </div>

                <ng-container *ngIf="config.headerPanelConfig?.actions">
                    <div *ngIf="isHeaderActionsAvailable"
                         class="actions-wrapper">
                        <ng-container *ngFor="let action of config.headerPanelConfig.actions">
                            <div *ngIf="!isHide(action)"
                                 class="action-element">
                                <div class="action-btn">
                                    <button
                                        class="btn btn-primary"
                                        [disabled]="isDisable(action)"
                                        [ngClass]="{'disabled': isDisable(action)}"
                                        [ngStyle]="{'background-color': action.actionTypeProps?.bgColour || ''}"
                                        [tooltip]="action.tooltipText"
                                        [isDisabled]="!isDisable(action) || !action.tooltipText"
                                        [container]="'body'"
                                        (click)="onActionClick(action)"
                                        translate>
                                        {{ action.text }}
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="!config?.hideFilterPanel">
            <div class="cs-list-filter-panel">
                <div class="filter-section flex-1">
                    <div class="search" *ngIf="!config.filterPanelConfig?.hideSearchBox">
                        <app-cs-search-bar (onItemSearch)="onSearch($event)"></app-cs-search-bar>
                    </div>
                    <div class="filters flex-1 filter-comp-container" *ngIf="!config.filterPanelConfig?.hideFilters">
                        <app-filter
                            [widthChangeEvent]="filterWidthChangeEvent.asObservable()"
                            [availableFields]="config.filterPanelConfig?.filters"
                            [appliedFilters]="appliedFilter"
                            [screenType]="config.filterPanelConfig?.screen"
                            [dynamicPositionId]="config.filterPanelConfig?.dynamicPositionId"
                            [requiredDateConditions]="config.filterPanelConfig?.requiredDateConditions || []"
                            (applyFilter)="onFilter($event, 'apply')"
                            (deleteFilter)="onFilter($event, 'remove')">
                        </app-filter>
                    </div>
                </div>
                <ng-container *ngIf="!config?.filterPanelConfig?.hideActions">
                    <div class="action-section" *ngIf="config?.filterPanelConfig?.actions?.length">
                        <div class="actions-wrapper">
                            <ng-container *ngFor="let action of config.filterPanelConfig.actions">
                                <div *ngIf="!isHide(action)" class="action-element">
                                    <ng-container *ngIf="action.actionType == 'icon'; else buttonTemplate">
                                        <div class="grid-action-container">
                                            <div class="action-btn-icon pointer" (click)="onActionClick(action)">
                                                <span>
                                                     <i [class]="action.actionTypeProps?.class || ''"></i>
                                                </span>
                                                <span class="action-btn-text">
                                                    {{ action.text }}
                                                </span>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-template #buttonTemplate>
                                        <div class="action-btn">
                                            <button
                                                class="btn btn-primary"
                                                [disabled]="isDisable(action)"
                                                [ngClass]="{'disabled': isDisable(action)}"
                                                [ngStyle]="{'background-color': action.actionTypeProps?.bgColour || ''}"
                                                [tooltip]="action.tooltipText"
                                                [isDisabled]="!isDisable(action) || !action.tooltipText"
                                                [container]="'body'"
                                                (click)="onActionClick(action)"
                                                translate>
                                                {{ action.text }}
                                            </button>
                                         </div>
                                    </ng-template>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <div class="cs-list w-100"
             [ngClass]="{'h-100': gridLayout === 'normal'}">
            <div class="cs-ag-grid-js w-100 h-100"
                 [ngClass]="{'no-data-grid': !totalRecords}"
                 #grid>
            </div>
        </div>

        <div class="cs-list-footer" *ngIf="isPagination">
            <ng-container *ngIf="!isDataLoading">
                <div class="cs-list-footer__pagination" *ngIf="totalRecords">
                    <div class="cs-pagination-panel">
                        <app-cs-pagination-panel
                            [totalRecord]="totalRecords"
                            [initialParams]="paginationParams"
                            [dropUpCalcAddOnSpace]="config.footerConfig?.layoutFooterHeight"
                            (onUpdatePagingParams)="updatePagingParams($event)">
                        </app-cs-pagination-panel>
                    </div>
                </div>
            </ng-container>

            <!-- ***** Can be enabled this pagination loader if needed ***** -->

            <!--            <ng-template #paginationPlaceholder>-->
            <!--                <div class="pagination-placeholder">-->
            <!--                    <div class="ph-col-12">-->
            <!--                        <div class="ph-row align-items-center">-->
            <!--                            <div class="ph-col-2"></div>-->
            <!--                            <div class="ph-col-8 empty"></div>-->
            <!--                            <div class="ph-col-2"></div>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </ng-template>-->
        </div>
    </ng-container>
</div>
